import { useMemo, useState, useEffect } from "react";

/**
 *  React hook that returns true if user scrolled down to a specified position.
 *
 * @param {number} triggerPosition - scrollY (in px) at which scrollHandler returns true
 * @return {boolean} scrolledDownToTrigger
 */
const useScrollHandler = (triggerPosition) => {
    // setting initial value to true
    const [scroll, setScroll] = useState(false);

    // running on mount
    useEffect(() => {
        if (!document || !window) return;

        const onScroll = () => {
            const scrollCheck = window.scrollY > triggerPosition;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        };

        // setting the event handler from web API
        document.addEventListener("scroll", onScroll);

        // cleaning up from the web API
        return () => {
            document.removeEventListener("scroll", onScroll);
        };
    }, [scroll, setScroll, triggerPosition]);

    return scroll;
};

const useSafeScroll = (triggerPosition, tollerance = 40) => {
    const preScrollPositionReached = useScrollHandler(triggerPosition - tollerance);
    const scrollPositionReached = useScrollHandler(triggerPosition);

    const [fullyScrolled, setFullyScrolled] = useState(false);

    const [scroll, setScroll] = useState(false)

    useEffect(() => {
        if (fullyScrolled && !scroll) {
            setScroll(true)
        }

        if (scrollPositionReached && !scroll) {
            setFullyScrolled(true);
            setScroll(true);
        }

        if (fullyScrolled && !preScrollPositionReached && scroll) {
            setFullyScrolled(false);
            setScroll(false)
        }
    }, [preScrollPositionReached, scrollPositionReached, fullyScrolled]);

    return scroll
}

export { useScrollHandler, useSafeScroll };
